import React from "react";

// Artwork des monnaies. Les deux fichiers vivent dans `public/images/` :
// remplacez-les pour changer l'illustration, sans toucher au code — les tailles
// et les alignements ci-dessous s'adaptent à n'importe quel carré.
export const COIN_ART = {
  coin: "/sprite/coin.svg",
  junk: "/sprite/junk-coin.svg",
};

// `kind` : "coin" (pièces) ou "junk" (pièces de consolation).
function Coin({ kind = "coin", size = 22, className = "", alt = "" }) {
  return (
    <img
      src={COIN_ART[kind] || COIN_ART.coin}
      alt={alt}
      aria-hidden={alt ? undefined : "true"}
      className={`pq-coin${className ? " " + className : ""}`}
      style={{ width: size, height: size }}
      draggable="false"
    />
  );
}

export default Coin;
